import React, { useState } from 'react';
import { countLabel, RecordToolbar } from 'components/record-shell/RecordList';
import { Grid } from '@mui/material';

import ConfirmDialog from 'components/confirm-dialog/ConfirmDialog';
import ProcedureProductsList from './list/ProcedureProductsList';
import ProcedureProductForm from './form/ProcedureProductForm';
import { Procedure, ProcedureProduct } from 'types/procedure';

interface ProcedureProductsProps {
  procedure: Procedure;
  handleChangeAddProduct(product: ProcedureProduct): void;
  handleDeleteProduct(product: ProcedureProduct): void;
}

const ProcedureProducts: React.FC<ProcedureProductsProps> = ({
  procedure,
  handleDeleteProduct,
  handleChangeAddProduct,
}) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<ProcedureProduct | null>(null);
  const [productInfo, setProductInfo] = useState<ProcedureProduct>({
    quantity: 0,
    product: null,
    id: 0,
    product_id: 0,
  });

  function handleChangeProductInfo(index: keyof ProcedureProduct, value: any) {
    setProductInfo(prev => ({ ...prev, [index]: value }));
  }

  function handleAddProduct(productInfo: ProcedureProduct | null) {
    if (!productInfo) return;
    handleChangeAddProduct(productInfo);
    setAddDialogOpen(false);
    setProductInfo({
      quantity: 0,
      product_id: 0,
      id: 0,
      product: null,
    });
  }

  function onExited() {
    setAddDialogOpen(false);
    setProductInfo({
      id: 0,
      quantity: 0,
      product: null,
      product_id: 0,
    });
    setEditDialogOpen(false);
  }

  function handleEditProduct(procedure: ProcedureProduct, index: number) {
    setEditDialogOpen(true);
    setProductInfo(procedure);
  }

  return (
    <Grid container size={12} spacing={2}>
      {confirmDialogOpen && (
        <ConfirmDialog
          confirmLabel="Excluir"
          destructive
          handleNoClick={() => setConfirmDialogOpen(null)}
          handleYesClick={() => {
            handleDeleteProduct(confirmDialogOpen);
            setConfirmDialogOpen(null);
          }}
          title="Tem certeza que deseja excluir este produto?"
        />
      )}
      <Grid size={12}>
        <RecordToolbar
          title={countLabel(
            procedure.products.length,
            'produto cadastrado',
            'produtos cadastrados',
            'Nenhum produto cadastrado',
          )}
          addLabel="Adicionar produto"
          onAdd={() => setAddDialogOpen(true)}
        />
      </Grid>

      {procedure.products.length > 0 && (
        <ProcedureProductsList
          products={procedure.products}
          handleDeleteProduct={product => setConfirmDialogOpen(product)}
          handleEditProduct={handleEditProduct}
        />
      )}

      {addDialogOpen && (
        <ProcedureProductForm
          type="new"
          handleChangeProductInfo={handleChangeProductInfo}
          productInfo={productInfo}
          handleAddProduct={handleAddProduct}
          onExited={onExited}
        />
      )}

      {!!productInfo.id && editDialogOpen && (
        <ProcedureProductForm
          type="edit"
          handleChangeProductInfo={handleChangeProductInfo}
          productInfo={productInfo}
          handleAddProduct={handleAddProduct}
          onExited={onExited}
        />
      )}
    </Grid>
  );
};

export default ProcedureProducts;
